import React from "react";

interface SubdivisionProductionData {
  benchmark: string; actualProduction: string; benchmarkPercent: string;
  percentOfBenchmark: string; bonusPercentEarned: string; bonusValue: string; score: string;
}
interface SubdivisionProductionSubFormProps {
  data: SubdivisionProductionData; isEditable: boolean; percentOfTotalAchievementScore: number;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>, options?: { type?: 'number' | 'decimal' | 'text'; maxLength?: number; minLength?: number; max?: number; min?: number }) => void;
}

const SubdivisionProductionSubForm: React.FC<SubdivisionProductionSubFormProps> = ({ data, isEditable, percentOfTotalAchievementScore, onInputChange }) => (
  <div className="sf-section">
    <h3 className="sf-title">Subdivision Production ({percentOfTotalAchievementScore}% of total achievement score)</h3>
    <div className="grid grid-cols-2 gap-6">
      <div className="space-y-2">
        <label className="sf-label">This quarter the benchmark was:</label>
        <input type="text" inputMode="numeric" pattern="[0-9]*" maxLength={3} minLength={1} max={120} min={0}
          name="operationalEfficiency.subdivisionProduction.benchmark" value={data.benchmark}
          onChange={e => onInputChange(e, { type: "number", maxLength: 3, minLength: 1 })}
          disabled={!isEditable} placeholder="0" onFocus={e => e.target.select()}
          className="sf-input mt-1 block w-full px-3 py-2 text-right" />
      </div>
      <div className="space-y-4">
        <div>
          <label className="sf-label">Actual Production %</label>
          <input type="text" inputMode="numeric" pattern="[0-9]*" maxLength={3} minLength={1}
            name="operationalEfficiency.subdivisionProduction.actualProduction" value={data.actualProduction}
            onChange={e => onInputChange(e, { type: "number", maxLength: 3, minLength: 1 })}
            disabled={!isEditable} placeholder="0" onFocus={e => e.target.select()}
            className="sf-input mt-1 block w-full px-3 py-2 text-right" />
        </div>
        <div>
          <label className="sf-label">Benchmark %</label>
          <input type="text" readOnly value={data.benchmark} className="sf-input-ro mt-1 block w-full px-3 py-2 text-right" />
        </div>
        <div>
          <label className="sf-label">% of Benchmark</label>
          <input type="text" readOnly name="operationalEfficiency.subdivisionProduction.percentOfBenchmark"
            value={data.percentOfBenchmark ? (parseFloat(data.percentOfBenchmark) * 100).toString() : ""}
            className="sf-input-ro mt-1 block w-full px-3 py-2 text-right" />
        </div>
      </div>
    </div>
    <p className="sf-hint">70%–120% of Benchmark</p>
    <div className="sf-results grid grid-cols-4 gap-4">
      <div>
        <div className="sf-results-label">Bonus % Earned</div>
        <input type="text" readOnly name="operationalEfficiency.subdivisionProduction.bonusPercentEarned"
          value={data.bonusPercentEarned ? parseInt(data.bonusPercentEarned) : ""}
          className="sf-input-ro w-24 px-2 py-1 text-right" />
      </div>
      <div>
        <div className="sf-results-label">{percentOfTotalAchievementScore}%</div>
        <input type="text" name="operationalEfficiency.subdivisionProduction.bonusValue" readOnly
          value={percentOfTotalAchievementScore && !isNaN(percentOfTotalAchievementScore) ? (percentOfTotalAchievementScore * 0.01).toFixed(2) : ""}
          className="sf-input-ro w-24 px-2 py-1 text-right" />
      </div>
      <div>
        <div className="sf-results-label">Score</div>
        <input type="text" name="operationalEfficiency.subdivisionProduction.score"
          value={data.score && !isNaN(parseInt(data.score)) ? parseInt(data.score) : "0"}
          disabled={!isEditable} onChange={onInputChange}
          className="sf-input-ro w-24 px-2 py-1 text-right" />
      </div>
    </div>
  </div>
);

export default SubdivisionProductionSubForm;